var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{directives:[{name:"grid-order",rawName:"v-grid-order"}],staticClass:"table-scroll mobile-cards table b-table table-hover table-borderless table-sm",class:{ autoheight: _vm.autoheight },attrs:{"id":_vm.id},on:{"sort":_vm.sort}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }